import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ContactsIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M19,3H7A2,2,0,0,0,5,5V6H6.5a.5.5,0,0,1,0,1H5v5H6.5a.5.5,0,0,1,0,1H5v5H6.5a.5.5,0,0,1,0,1H5a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3ZM13,7.65a2,2,0,1,1-2,2A2,2,0,0,1,13,7.65Zm3.52,9.08h-7a.5.5,0,0,1-.5-.57,4,4,0,0,1,8,0A.5.5,0,0,1,16.49,16.73Z"
  }), /*#__PURE__*/_jsx("rect", {
    x: "3",
    y: "4",
    width: "4",
    height: "2",
    rx: "1"
  }), /*#__PURE__*/_jsx("rect", {
    x: "3",
    y: "16",
    width: "4",
    height: "2",
    rx: "1"
  }), /*#__PURE__*/_jsx("rect", {
    x: "3",
    y: "10",
    width: "4",
    height: "2",
    rx: "1"
  })]
}), 'ContactsIcon');